/* @flow */

import { em } from 'polished';

import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { headlineFontSize } from '@braindate/ui/lib/token/typography';

const fontWeights = {
  [1]: 700,
  [2]: 600,
  [3]: 600,
  [4]: 600,
  [5]: 600,
};

const fontSizes = {
  [1]: 18,
  [2]: 20,
  [3]: 16,
  [4]: 14,
  [5]: 14,
};

export default {
  root: {
    extend: antialiasing,

    margin: [em(24, headlineFontSize), 0, em(8, headlineFontSize)],

    textAlign: ({ level }: Object) => level === 1 && 'center',
    color: ({ theme, level }: Object) => level !== 1 && theme.accentColor,
    fontSize: ({ level }: Object) => fontSizes[level],
    fontWeight: ({ level }: Object) => fontWeights[level],
  },
};
